import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, Renderer2, RendererStyleFlags2, ViewChild } from '@angular/core';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-camera',
  templateUrl: './camera.component.html',
  styleUrls: ['./camera.component.scss']
})
export class CameraComponent implements OnInit {
  @Output('capturedImage') capturedImage: EventEmitter<any> = new EventEmitter();
  @Output('smileMeter') smileMeter: EventEmitter<any> = new EventEmitter();
  loading = true;
  showWebcam = true;
  allowCameraSwitch = true;
  multipleWebcamsAvailable = false;
  deviceId: string;
  facingMode: string = 'user';
  messages: any[] = [];
  timer: number = 3;
  timerText = 'Getting Ready';
  myInterval;
  // latst snapshot
  webcamImage: WebcamImage = null;stream: any;
  detection: any;
  resizedDetections: any;
  canvas: any;
  canvasEl: any;
  displaySize: any;
  videoInput: any;
  label = 'undefined';
  data = 0;
  @ViewChild('cam') cam: any;
  @ViewChild('cancancanvas') cancancanvas: ElementRef;
  
  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean|string> = new Subject<boolean|string>();

  constructor(private renderer: Renderer2) { 
    // Promise.all([faceapi.nets.tinyFaceDetector.loadFromUri('../../assets/models'),
    // faceapi.nets.faceLandmark68Net.loadFromUri('../../assets/models'),
    // faceapi.nets.faceExpressionNet.loadFromUri('../../assets/models')]).then(() => this.readAvailableVideoInputs());
  }

  async ngOnInit(): Promise<void> {
    }
  

  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    this.messages.push(error);
    if (error.mediaStreamError && error.mediaStreamError.name === 'NotAllowedError') {
      this.addMessage('User denied camera access');
    }
  }

  public showNextWebcam(directionOrDeviceId: boolean|string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }

  public handleImage(webcamImage: WebcamImage): void {
    this.addMessage('Received webcam image');
    this.webcamImage = webcamImage;
    this.toggleWebcam();
    this.capturedImage.emit({image: this.webcamImage, detection: this.detection});
  }

  public cameraWasSwitched(deviceId: string): void {
    this.addMessage('Active device: ' + deviceId);
    this.deviceId = deviceId;
    this.readAvailableVideoInputs();
  }

  addMessage(message: any): void {
    this.messages.unshift(message);
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean|string> {
    return this.nextWebcam.asObservable();
  }

  public get videoOptions(): MediaTrackConstraints {
    const result: MediaTrackConstraints = {};
    if (this.facingMode && this.facingMode !== '') {
      result.facingMode = { ideal: this.facingMode };
    }

    return result;
  }

  private readAvailableVideoInputs() {
    this.loading = true;
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {

      // console.log('text')
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });
      // setTimeout(async () => {
      // this.detectFaces();
      // },1000)
  }
  
}
